// changelog.js — TDA Events Platform
// Neueste Version zuerst. Typen: feature | major | improvement | bugfix | security

export const CHANGELOG = [
  {
    version: '2.2.8',
    date: '2026-08-07',
    type: 'security',
    title: 'Schnittstellen geben weniger preis',
    highlights: [
      'Status- und Fehlerauskünfte nennen keine internen Kennzahlen und keine Endpunktlisten mehr',
      'Der Divisionen-Katalog ist an eine Anmeldung gebunden; die Anmeldelinks nutzen ihren eigenen Zugang',
      'Anlegen, Ändern und Löschen von Kategorien meldet sich wieder korrekt an',
    ],
  },
  {
    version: '2.2.7',
    date: '2026-07-08',
    type: 'feature',
    title: 'Teilnehmer laden Brief selbst herunter',
    highlights: [
      'Nach der Selbst-Anmeldung: Download-Button für den eigenen Visa-Einladungsbrief',
      'Token-geschützt (kein Zugriff auf fremde Briefe/Passdaten)',
    ],
  },
  {
    version: '2.2.6',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Events im Header-Dropdown + Modal-Fix',
    highlights: [
      'Header-Dropdown listet jetzt auch „Events & Camps" (neben Turnieren)',
      'Dialoge opak & höhenbegrenzt (scrollen im Rahmen) – nicht mehr durchsichtig',
    ],
  },
  {
    version: '2.2.5',
    date: '2026-07-08',
    type: 'feature',
    title: 'Camp-Selbstanmeldung per Link',
    highlights: [
      'Öffentlicher Anmelde-Link je Camp – Teilnehmer tragen ihre Passdaten selbst ein (/camp/:id)',
      'Zweisprachiges Formular (EN/DE), kein Login nötig',
      'Link im Camp-Panel kopierbar; Admin-Fallback „Teilnehmer hinzufügen"',
    ],
  },
  {
    version: '2.2.4',
    date: '2026-07-08',
    type: 'bugfix',
    title: 'Menüpunkt „Lehrgänge & Camps"',
    highlights: [
      'Events-/Camp-Bereich war nicht im Menü verlinkt – jetzt Kachel in der Organisation-Übersicht',
      'Trainingscamps inkl. Visa-Briefe-Assistent darüber erreichbar',
    ],
  },
  {
    version: '2.2.3',
    date: '2026-07-08',
    type: 'feature',
    title: 'Briefe-Assistent: drucken, per E-Mail senden, Kopien',
    highlights: [
      'Assistent: Sammelbrief / Einzelbrief / Einzelbriefe an alle Teilnehmer',
      'Ausgabe wählbar: PDF herunterladen (Ausdruck) oder per E-Mail',
      'E-Mail-Empfänger: Botschaft, Teilnehmer oder eigene Adresse',
      'Anzahl Ausfertigungen (Kopien) je Brief einstellbar; Botschafts-E-Mail speicherbar',
    ],
  },
  {
    version: '2.2.2',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Visa-Brief mit Verbands-Briefkopf & gebrandete E-Mail',
    highlights: [
      'Offizieller Briefkopf mit TDA-Verbandslogo (Tiger & Dragon Association Int\'l) im PDF',
      'Begleit-E-Mail im TDA-Markenlayout (Banner) statt Klartext',
    ],
  },
  {
    version: '2.2.1',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Visa-Brief: fester Absender pro Camp',
    highlights: [
      'Absender (Organisation, Ansprechpartner, Anschrift, E-Mail, Telefon) pro Camp hinterlegbar',
      'Erscheint fest im Briefkopf & in der Unterschrift – unabhängig vom Login-Konto',
    ],
  },
  {
    version: '2.2.0',
    date: '2026-07-07',
    type: 'feature',
    title: 'Trainingscamp & Visa-Einladungsbriefe',
    highlights: [
      'Event-Typ "Camp" mit Botschafts-/Visa-Daten (Zielland, Botschaftsanschrift)',
      'Passdaten je Teilnehmer erfassen (Reisepass, Nationalität, Geburtsort, Anschrift)',
      'Einzel-Einladungsbrief pro Teilnehmer als PDF – zweisprachig Deutsch/Englisch',
      'Sammel-Nominierungsschreiben mit Teilnehmer-Tabelle als PDF (DE/EN)',
    ],
  },
  {
    version: '2.1.0',
    date: '2026-03-23',
    type: 'feature',
    title: 'Staff-Management & Einsatzplan',
    highlights: [
      'Neue Rollen: Turnierleitung, Anmeldung, Ombudsmann',
      'Mehrere Rollen pro Person möglich',
      'Vollständiger Einsatzplan mit Matten-Raster',
      'Rollenbasierte Filterung in Zuweisung-Dropdowns',
    ],
  },
  {
    version: '2.0.0',
    date: '2026-03-20',
    type: 'major',
    title: 'Formen-Übersicht & Mattenfläche',
    highlights: [
      'Formen-Dashboard: Kategorie-Übersicht mit Matte-Zuweisung',
      'Neuer Mattenfläche-Bereich mit Schreiber-Links',
      'Turnier-Auswahl jetzt im globalen Header sichtbar',
      'Hilfe-Modal mit Modulbeschreibungen und Versionierung',
    ],
  },
  {
    version: '1.9.0',
    date: '2026-03-10',
    type: 'feature',
    title: 'Saison-Rangliste',
    highlights: [
      'Saison-Rangliste für TDA-weit verwaltbar',
      'Öffentliches Widget für tda-intl.com und tda-vib.de',
      'Veröffentlichen / Zurückziehen per Schalter',
    ],
  },
  {
    version: '1.8.0',
    date: '2026-02-15',
    type: 'feature',
    title: 'Kampfflächen-Manager',
    highlights: [
      'Matten und Bereiche anlegen und benennen',
      'Matten Formen-Kategorien zuordnen',
      'Nummernvergabe für Mattenübersicht',
    ],
  },
  {
    version: '1.7.0',
    date: '2026-01-20',
    type: 'improvement',
    title: 'Wettkämpfer-Dashboard Überarbeitung',
    highlights: [
      'Kompakte Filter-Leiste (Gewicht, Alter, Level in einer Zeile)',
      'Statistik-Chips statt großer Stat-Karten',
      'Schnellsuche nach Name',
    ],
  },
];
